import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DatePipe } from '@angular/common';
import { UiformBaseComponent } from '../components/uiform/uiform-base/uiform-base.component';

@Component({
  selector: 'app-view-report',
  templateUrl: './view-report.component.html',
  styleUrls: ['./view-report.component.css'],
})
export class ViewReportComponent extends UiformBaseComponent {
  @ViewChild('content')
  content!: ElementRef;
  public sanitizedData: any = [];
  public reportData: any = {};
  public reportTitle: any = '';
  public searchReport: any;
  public loading: boolean = false;
  dropdownOpen: boolean = false;
  public selectedSearchAtt: any;
  searchData: any = {};
  searchView: any = {};

  public reqform: any = {
    chart_type: 'html',
    margins: false,
  };
  public pivotform: any = {
    chart_type: 'html',
  };

  private sanitizer = inject(DomSanitizer);
  pivotUrl: SafeResourceUrl | null = null;
  pivottable: any = '<div><div>';
  pdfContent: any = '';

  @Input() uiformid: any;
  @Input() titlereport: any;
  @Input() searchdata: any;
  @Input() flag: any;
  @Input() searchList: any;
  @Input() uiFormData: any;
  @Input() autoUpdateReport: any;

  override ngOnInit() {
    let _self = this;
    _self.getDetails(
      _self.flag,
      _self.searchdata,
      _self.titlereport,
      _self.uiformid,
    );
    _self.preload();
  }

  /**
   * Reset search from
   */
  override resetSearchForm() {
    this.form.searchError = false;
    this.form.searchMessage = '';
    this.form.searchParams = {};
  }

  override preload() {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    this.locator.config
      .getProperty('endpoint.reports')
      .then((property: any) => {
        this.locator.http.get(_self.api.preload, (res: any, error: any) => {
          if (error) {
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.result.message;
          if (res.success) {
            _self.form.preload = res.result;
            // Set a 2-second delay to call clearMessage
            setTimeout(() => {
              this.clearMessage(_self.form);
            }, 2000);
          }
        });
      });
  }

  /**
   * Main function to get Pivot GUI
   * @param flag
   */
  async searchAndDraw(flag: boolean, searchdata: any, title: any) {
    let _self = this;
    _self.reportTitle = title;
    _self.reqform = searchdata;
    if (flag) {
      this.searchCriteria(() => {
        _self.cleanData();
        _self.findNumericFields();
        _self.getPivotGui();
      });
    } else {
      _self.getPivotGui();
    }
  }

  /**
   * Remove common attributes from searched result data
   */
  public cleanData(): any {
    let _self = this;
    const allowedKeysMap = _self.filterAttributes.reduce(
      (map: any, attr: any) => {
        if (attr['code'] && attr['label']) {
          map[attr['code']] = attr['label'];
        }
        return map;
      },
      {},
    );

    _self.sanitizedData = _self.usecaseData.map((item: any) => {
      const sanitizedItem: any = {};
      Object.keys(allowedKeysMap).forEach((key: string) => {
        if (key in item) {
          sanitizedItem[allowedKeysMap[key]] = item[key];
        }
      });
      return sanitizedItem;
    });
  }

  /**
   * Create Pivot GUI from server side
   */
  chartHtml: any;
  chartUrl: any = null;
  getPivotGui() {
    let _self = this;
    _self.loading = true;
    _self.reportData = {};
    _self.form['error'] = false;
    _self.form['message'] = '';
    _self.pivottable = '';
    _self.pivotUrl = null;
    _self.chartUrl = null;
    _self.chartHtml = null;
    _self.reqform['title'] = _self.usecase['name'];
    _self.reqform['values'] = this.reqform['aggfunc']
      ? Object.keys(this.reqform['aggfunc'])
      : [];
    _self.reqform['numericfields'] = _self.findNumericFields();
    _self.reportData = _self.reqform;

    // if (
    //   _self.reqform &&
    //   (_self.reqform['index'] != null || _self.reqform['columns'] != null)
    // ) {

    _self.locator.config
      .getProperty('endpoint.pivot')
      .then((property: string) => {
        let url = _self.urlRewrite(property);
        _self.reqform['data'] = _self.sanitizedData;

        let client = _self.locator.http.getClient();
        client.post(url, _self.reqform, { responseType: 'text' }).subscribe(
          (data: any) => {
            try {
              const jsonResponse = JSON.parse(data);
              if (!jsonResponse['success']) {
                _self.form['error'] = true;
                _self.form['message'] = jsonResponse['message'];
                _self.loading = false;
                return;
              }
            }
            // catch (error) {
            //   // ✅ HTML chart aaya
            //   _self.chartHtml = data;
            //   _self.pivottable = '';

            //   // 🔥 IMPORTANT: convert HTML → iframe URL
            //   const blob = new Blob([data], { type: 'text/html' });
            //   const url = URL.createObjectURL(blob);

            //   _self.chartUrl =
            //     this.sanitizer.bypassSecurityTrustResourceUrl(url);
            // }
            catch (error) {

              // 🔥 Detect: Chart ya Table
              if (data.includes('Plotly.newPlot') || data.includes('plotly')) {

                // ✅ Chart case
                _self.chartHtml = data;
                _self.pivottable = '';

                const blob = new Blob([data], { type: 'text/html' });
                const url = URL.createObjectURL(blob);

                _self.chartUrl =
                  this.sanitizer.bypassSecurityTrustResourceUrl(url);

              } else {

                // ✅ Table case
                _self.pivottable = data;
                _self.chartUrl = null;
              }
            }

            _self.loading = false;
          },
          (error: any) => {
            _self.form['error'] = true;
            _self.form['message'] = 'Error loading pivot table';
            _self.loading = false;
            console.error('Error:', error);
          }
        );
      });
  }

  /**
   * Function to find all numeric fields
   * @returns
   */
  findNumericFields = () => {
    const numericFields = new Set();
    this.sanitizedData.forEach((item: any) => {
      Object.keys(item).forEach((key) => {
        if (typeof item[key] === 'number') {
          numericFields.add(key);
        }
      });
    });
    return Array.from(numericFields);
  };

  /**
   * Reset search values
   */
  resetSearchValues() {
    this.searchValues = {};
    this.searchAndDrawnew(true);
  }

  /**
   * Update form field
   * @param field
   * @param value
   * @param aggValue
   * @param isKey
   */
  updateFormField(
    field: string,
    value: any,
    aggValue?: any,
    isKey: boolean = false,
  ) {
    this.reqform[field] = this.reqform[field] || (isKey ? {} : []);
    if (isKey) {
      aggValue = aggValue?.trim() || 'sum';
      this.reqform[field][value] = aggValue;
    } else {
      this.reqform[field].push(value);
    }
  }

  /**
   * Remove form field
   * @param field
   * @param value
   * @param isKey
   */
  removeFormField(field: string, value: any, isKey: boolean = false) {
    if (isKey) {
      delete this.reqform[field]?.[value];
    } else if (Array.isArray(this.reqform[field])) {
      const index = this.reqform[field].indexOf(value);
      if (index > -1) this.reqform[field].splice(index, 1);
    }
  }

  /**
   * Search and draw pivot data
   * @param flag
   * @param searchdata
   * @param title
   * @param uiformId
   */
  async getDetails(flag: boolean, searchdata: any, title: any, uiformId: any) {
    let _self = this;
    _self.is_paging = false;

    if (uiformId) {
      try {
        const endpoint =
          await _self.locator.config.getProperty('endpoint.ui.forms');

        await new Promise<void>((resolve) => {
          _self.get(uiformId, async function () {
            _self.usecaseId = _self.form.data.userstoryId;

            await _self.getUsecaseSchema(false, async () => {
              _self.filterAttributes = await _self.getFilterAttributes(
                _self.usecaseAttributes,
                _self.form.data['fields'],
              );
              resolve();
            });
          });
        });

        // Call searchAndDraw only after all operations are complete
        _self.searchAndDraw(flag, searchdata, title);
      } catch (error) {
        console.error('Error in getDetails:', error);
      }
    }
  }

  /**
   * Draw pivot data
   * @param flag
   */
  searchAndDrawnew(flag: boolean) {
    let _self = this;
    if (flag) {
      this.searchCriteria(() => {
        _self.cleanData();
        _self.findNumericFields;
        _self.getPivotGui();
      });
    } else {
      _self.getPivotGui();
    }
  }

  /**
   * search for parent usecase dependency
   * @param e
   * @param value
   */
  override onSearchReferenceValueChange(e: any, value: any) {
    this.searchValues[e.code] =
      e.type === 'number' ? parseFloat(value.target.value) : value.target.value;
    let _self = this;
    if (
      _self.usecase !== undefined &&
      _self.usecase['parentUsecaseDependency'] !== undefined &&
      _self.usecase['parentUsecaseDependency'][e['primaryUsecase']] !==
        undefined
    ) {
      _self.primaryUsecaseDependencyFilter(
        _self.usecase['parentUsecaseDependency'][e['primaryUsecase']],
        value,
      );
    }
  }

  /***
   * primaryUsecaseDependencyFilter
   */
  primaryUsecaseDependencyFilter(data: any, val: any) {
    let _self = this;
    let key = val['target']['id'];
    let [appCode, codes] = (data['code'] ?? '').toString().split('.');
    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/' +
      appCode +
      '/' +
      codes +
      '/preloadData';
    let searchParams = {
      [key]: parseFloat(val['target']['value']),
    };
    _self.locator.http.post(
      url,
      searchParams,
      function (res: any, error: boolean) {
        if (error) {
          return;
        }
        _self.form.preload[data['code']] = res.result[data['code']];
      },
    );
  }

  /**
   * add search data
   */
  addSearchData() {
    let _self = this;

    if (!_self.searchData['field']) {
      alert('Field is empty');
      return;
    } else if (!_self.searchData['condition']) {
      alert('Condition is empty');
      return;
    } else if (!_self.searchData['value']) {
      alert('Value is empty');
      return;
    } else {
      const normalizedNumericFields = _self
        .findNumericFields()
        .map((label: any) => label.toLowerCase().replace(/\s+/g, ''));
      const normalizedField = _self.searchData.field
        .toLowerCase()
        .replace(/\s+/g, '');
      if (normalizedNumericFields.includes(normalizedField)) {
        const numValue = Number(_self.searchData.value);
        if (!isNaN(numValue)) {
          _self.searchData.value = numValue;
        }
      }
      _self.searchList.push(_self.searchData);
      _self.searchData = {};
    }
    this.searchView['field'] = '';
  }

  /**
   * Reset search data
   * @param index
   */
  removeSearchData(index: any) {
    if (index > -1) this.searchList.splice(index, 1);
  }

  /**
   * Reset search criteria
   */
  resetSearchCriteria() {
    this.searchList = [];
    this.searchData = {};
    this.searchView = {};
  }

  /**
   * Search criteria
   * @param callback
   */
  searchCriteria(callback?: any) {
    let _self = this;

    const datePipe = new DatePipe('en-US');
    _self.searchList.forEach((e: any) => {
      const currentDate = new Date();
      if (e?.date === 'today') {
        console.log('today');

        e['value'] = datePipe.transform(currentDate, 'yyyy-MM-dd');
      } else if (e?.date === 'yesterday') {
        console.log('yesterday');
        const yesterday = new Date(currentDate.getTime() - 1);
        e['value'] = datePipe.transform(yesterday, 'yyyy-MM-dd');
      }
    });
    let searchCriteria = {
      searchList: _self.searchList,
    };

    let url = _self.apiurl + '/searchCriteria';

    this.locator.http.post(
      url,
      searchCriteria,
      function (res: any, error: any) {
        if (error) {
          if (callback) {
            callback(error);
          }

          return;
        }

        if (res.success) {
          _self.usecaseData = res.result['data'];
          // Add data in Datatable
          //_self.initializeDataTable();

          if (callback) {
            callback();
          }
        }

        if (callback) {
          callback();
        }
        _self.processData();
      },
    );
  }

  /**
   * Button labels for pivot table
   * @param type
   * @returns
   */
  getButtonLabels(type: string): string {
    const typeMap: { [key: string]: string } = {
      text: 'T',
      number: 'N',
      long: 'N',
      date: 'D',
      decimal: 'N',
      doc: 'Doc',
      email: 'E',
      expression: 'Exp',
      file: 'F',
      list: 'L',
      map: 'C',
      object: 'O',
      password: 'Pwd',
      phone: 'Phn',
      textarea: 'TA',
      url: 'Url',
    };
    return typeMap[type]; // Default '?' if type is unknown
  }

  /**
   * Button class for pivot table
   * @param type
   * @returns
   */
  getButtonClass(type: string): string {
    const typeClassMap: { [key: string]: string } = {
      text: 'text-bg-success',
      number: 'text-bg-primary',
      date: 'text-bg-warning',
      long: 'text-bg-primary',
      decimal: 'text-bg-primary',
      doc: 'text-bg-info',
      email: 'text-bg-success', // Email gets green
      expression: 'text-bg-info',
      file: 'text-bg-secondary',
      list: 'text-bg-danger', // List gets red
      map: 'text-bg-dark', // Map gets dark
      object: 'text-bg-secondary',
      password: 'text-bg-warning',
      phone: 'text-bg-success',
      textarea: 'text-bg-success',
      url: 'text-bg-info',
      // Add new mappings
      keyvalue: 'text-bg-info',
      image: 'text-bg-info',
    };
    return typeClassMap[type] || 'text-bg-success'; // Default grey
  }

  /**
   * Toggle dropdown
   */
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  /**
   * Select column value set
   * @param value
   * @param key
   */
  selectColumn(value: string, key: string) {
    this.pivotform[key] = value;
  }

  /**
   * Select search value set
   * @param value
   * @param key
   */
  selectSearch(value: any, key: string) {
    this.searchData[key] = value['code'];
    this.searchData['label'] = value['label'];
    this.searchView[key] = value['label'];
    if (key === 'field') {
      this.getType(this.searchData['field']);
    }
  }

  /**
   * Get type of value
   * @param value
   */
  getType(value: any) {
    let _self = this;
    _self.filterAttributes.forEach((e: any) => {
      if (e.code === value) {
        this.searchData['value'] = '';
        _self.selectedSearchAtt = e?.type;
      }
    });
  }

  /**
   * Filter type operators
   */
  operators = [
    { label: '=', value: 'EQ' },
    { label: '!=', value: 'NEQ' },
    { label: '>', value: 'GT' },
    { label: '<', value: 'LT' },
    { label: '>=', value: 'GTE' },
    { label: '<=', value: 'LTE' },
    { label: 'like', value: 'LIKE' },
  ];

  /**
   * Export data in PDF
   */
  /**
   * Export data in PDF with improved wide table handling
   */

  // public exportPDFData(): void {
  //   const _self = this;

  //   // Fetch the dashboard endpoint from configuration
  //   this.locator.config
  //     .getProperty('endpoint.api.v1')
  //     .then((property: string) => {
  //       const keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
  //       let sid = localStorage.getItem(keySuffix + 'sessionId');

  //       // If sessionId is not found in local storage, default to '0'
  //       if (!sid) {
  //         sid = '0';
  //       }

  //       const url = `${property}/${this.appId}/${this.uiformId}/reportPdf;jsessionid=${sid}`;

  //       // Prepare HTML content for PDF generation
  //       const tableStyle = `
  //       <style>
  //         @page {
  //           size: A4 landscape;
  //           margin: 5mm;
  //         }
  //         body {
  //           margin: 0;
  //           padding: 0;
  //         }
  //         table {
  //           border-collapse: collapse;
  //           width: 100%;
  //           table-layout: fixed;
  //           page-break-inside: auto;
  //           font-family: 'NotoSerifGujarati', sans-serif;
  //         }
  //         th, td {
  //           border: 1px solid #ddd;
  //           padding: 3px;
  //           font-size: 7px;
  //           word-wrap: break-word;
  //           overflow-wrap: break-word;
  //           text-align: center;
  //         }
  //         th {
  //           background-color: #f2f2f2;
  //           font-weight: bold;
  //         }
  //         tr {
  //           page-break-inside: avoid;
  //           page-break-after: auto;
  //         }
  //       </style>
  //     `;

  //       const htmlContent = `
  //       <html>
  //         <head>${tableStyle}</head>
  //         <body>
  //           <div style="width: 100%; overflow: hidden;">
  //             ${_self.pivottable}
  //           </div>
  //         </body>
  //       </html>
  //     `;
  //       console.log(url);
  //       // Send the HTML content to the backend to generate PDF
  //       _self.locator.http
  //         .getClient()
  //         .post(url, { html: htmlContent }, { responseType: 'blob' })
  //         .subscribe(
  //           (data: any) => {
  //             _self.downloadDataAsFile(data, 'export.pdf');
  //           },
  //           (error: any) => {
  //             console.error('PDF generation failed:', error);
  //             alert(
  //               'Failed to generate PDF. Please try again or contact support.',
  //             );
  //           },
  //         );
  //     });
  // }


  public async exportPDFData(): Promise<void> {
    const _self = this;

    try {

      // =====================================
      // CHART MODE
      // =====================================
      if (_self.chartUrl) {

        await this.waitForIframeLoad();

        const iframe = this.content?.nativeElement?.querySelector('iframe') as HTMLIFrameElement;

        if (!iframe?.contentWindow) {
          console.error('Iframe not found');
          return;
        }

        const iframeWin = iframe.contentWindow;
        const Plotly = (iframeWin as any).Plotly;

        if (!Plotly) {
          console.error('Plotly not found');
          return;
        }

        let chartDiv =
          iframeWin.document.getElementById('plotly-chart') ||
          iframeWin.document.querySelector('.plotly-graph-div');

        if (!chartDiv) {
          console.error('Chart div not found');
          return;
        }

        const svgData = await Plotly.toImage(chartDiv, {
          format: 'svg',
          width: 1400,
          height: 700
        });

        let svgText = '';

        if (svgData.startsWith('data:image/svg+xml')) {
          svgText = decodeURIComponent(svgData.split(',')[1]);
        }

        const html = `
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <style>
        @page{
          size:A4 landscape;
          margin:5mm;
        }

        body{
          margin:0;
          padding:0;
          text-align:center;
        }

        svg{
          width:100%;
          height:auto;
        }
      </style>
      </head>

      <body>
        ${svgText}
      </body>
      </html>
      `;

        _self.pdfContent = html;
        _self.sendPDFRequest(true);

        return;
      }

      // =====================================
      // TABLE MODE
      // =====================================

      let tableElement =
        this.content?.nativeElement?.querySelector('.pvtTable') ||
        this.content?.nativeElement?.querySelector('table');

      if (!tableElement) {
        console.error('Table not found');
        alert('No table found');
        return;
      }

      const tableHtml = tableElement.outerHTML;

      const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">

      <style>

        @page {
          size: A4 landscape;
          margin: 5mm;
        }

        body {
          margin: 0;
          padding: 0;
          font-family: Arial, sans-serif;
        }

        table {
          border-collapse: collapse;
          width: 100%;
          table-layout: fixed;
          page-break-inside: auto;
        }

        th,
        td {
          border: 1px solid #ddd;
          padding: 4px;
          font-size: 8px;
          word-wrap: break-word;
          overflow-wrap: break-word;
          text-align: center;
        }

        th {
          background: #f2f2f2;
          font-weight: bold;
        }

        tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }

        img {
          max-width: 100%;
          height: auto;
        }

      </style>

    </head>

    <body>

      <div style="width:100%;">
        ${tableHtml}
      </div>

    </body>
    </html>
    `;

      _self.pdfContent = html;
      _self.sendPDFRequest(false);

    } catch (error) {
      console.error('PDF Export Error', error);
      alert('PDF Export Failed');
    }
  }

  private sendPDFRequest(isSvg: boolean): void {

    const _self = this;

    this.locator.config
      .getProperty('endpoint.api.v1')
      .then((property: string) => {

        const keySuffix =
          this.locator.config.get('CONTEXT_PATH') + '-';

        let sid =
          localStorage.getItem(keySuffix + 'sessionId');

        if (!sid) {
          sid = '0';
        }

        const url =
          `${property}/${this.appId}/${this.uiformId}/reportPdf;jsessionid=${sid}`;

        _self.locator.http
          .getClient()
          .post(
            url,
            {
              html: _self.pdfContent,
              svg: isSvg
            },
            {
              responseType: 'blob'
            }
          )
          .subscribe(
            (data: any) => {
              _self.downloadDataAsFile(
                data,
                'export.pdf'
              );
            },
            (error: any) => {
              console.error(
                'PDF generation failed',
                error
              );

              alert(
                'Failed to generate PDF'
              );
            }
          );
      });
  }

  /**
   * Downalod data as file
   * @param data
   * @param fileName
   */
  public downloadDataAsFile(data: any, fileName: string) {
    //Create a dynamic link and download file
    let file = new window.Blob([data], { type: 'application/pdf' });
    const downloadAncher = document.createElement('a');
    downloadAncher.style.display = 'none';
    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = fileName;
    downloadAncher.click();
  }


  private waitForIframeLoad(): Promise<void> {
    return new Promise((resolve) => {
      const iframe = this.content?.nativeElement?.querySelector('iframe');

      if (!iframe) {
        resolve();
        return;
      }

      if ((iframe as HTMLIFrameElement).contentDocument?.readyState === 'complete') {
        resolve();
        return;
      }

      iframe.addEventListener('load', () => resolve(), { once: true });
    });
  }
}
